import { render, staticRenderFns } from "./DOC.vue?vue&type=template&id=6e75d0c2&scoped=true&"
import script from "./DOC.vue?vue&type=script&lang=js&"
export * from "./DOC.vue?vue&type=script&lang=js&"
import style0 from "./DOC.vue?vue&type=style&index=0&id=6e75d0c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e75d0c2",
  null
  
)

export default component.exports
import {QHeader,QToolbar,QToolbarTitle,QCard,QCardSection,QSpace,QSelect,QBtn,QList,QItem,QItemSection,QItemLabel,QPagination,QInnerLoading,QSpinnerGears,Ripple} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QToolbarTitle,QCard,QCardSection,QSpace,QSelect,QBtn,QList,QItem,QItemSection,QItemLabel,QPagination,QInnerLoading,QSpinnerGears}, component.options.components || {})
component.options.directives = Object.assign({Ripple}, component.options.directives || {})
